/* tslint:disable */

/**
 */
export class ProductCharColorParam {
    ID_COLOR?: number;
    LAYER_ORDER?: number;
}



// WEBPACK FOOTER //
// /home/dfm/cryosoft/ui/src/app/api/models/product-char-color-param.ts